import { Hero } from "./_components/sections/hero";
import {
  TrustedBy,
  ProductPillars,
  WorkflowsSection,
  ImpactSection,
  Why,
  StatsBand,
  TestimonialSpotlight,
  Testimonials,
  ClosingCTA,
} from "./_components/sections/sections";

export default function LandingPage() {
  return (
    <>
      <Hero />
      <TrustedBy />
      <ProductPillars />
      <WorkflowsSection />
      <ImpactSection />
      <Why />
      <StatsBand />
      <Testimonials />
      <TestimonialSpotlight />
      <ClosingCTA />
    </>
  );
}
